/**
 * The catch-all route. A dead URL is a dead end either way, so this one at
 * least says plainly that the path was checked and there is nothing at it.
 */

import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="notfound">
      <img
        className="notfound__image"
        src="/bear/bear-asleep.webp"
        alt="A grizzly bear asleep on a blanket in front of an open vault door, a child's crayon drawing of him taped to it."
        decoding="async"
      />
      <h2 className="notfound__title">Page not found</h2>
      <p className="notfound__lead">Big Bear checked this path twice. There&rsquo;s nothing here.</p>
      <p className="muted">He naps between verify runs — this page is a good spot.</p>
      <p className="notfound__home">
        <Link to="/">Back to the home page</Link>
      </p>
    </section>
  );
}
